import VisibilityLevel from "../model/VisibilityLevel";
import { formatBooleanValue } from "../../util";

const VisibilityLevelMapper = (item: any) => {
  let visibilityLevel = VisibilityLevel(item);
  visibilityLevel.valid = formatBooleanValue(item.valid);

  return visibilityLevel;
};

export default VisibilityLevelMapper;
